export enum TypeOfCustomer {
  PRIVATE_CLIENT = 'private client',
  CORPORATE_CUSTOMER = 'corporate customer'
}
